<template>
  <div>
    <Filters
      ref="filters"
      :resource="$sdk.note"
      :filters.sync="filters"
      class="mb-3"
      @apply="() => $refs['notes'].reload()"
      @ready="() => $refs['notes'].load()"
    />
    <el-card shadow="never">
      <div slot="header">
        <span>Notes</span>
        <el-button
          type="text"
          @click.native="$refs.notes.create()"
        >
          Create
        </el-button>
      </div>
      <Notes
        ref="notes"
        :resource="$props.schedule"
        truncate
        paginate
        :limit="10"
      />
    </el-card>
  </div>
</template>

<script>
import Filters from '@/components/Filters/Complex'
import Notes from '@/components/Notes'
export default {
  components: {
    Filters,
    Notes
  },
  props: {
    schedule: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      filters: []
    }
  }
}
</script>
